app.factory('icdModel', ['$rootScope', '$q', 'baseModel', 'icdService',
    function($rootScope, $q, baseModel, icdService) {

        function IcdModel() {
            this.getFavouriteIcd10List = function(doctorID) {
                return icdService.getFavouriteIcd10List(doctorID).then(
                    function (favouriteIcd10List) {
                        $rootScope.$broadcast(Event.ICD.ICD_10.GET_FAVOURITES.SUCCESS, favouriteIcd10List);
                        return favouriteIcd10List;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.ICD.ICD_10.GET_FAVOURITES.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };

            this.getPatientDiagnosisHistory = function(doctorID, patientID) {
                return icdService.getPatientDiagnosisHistory(doctorID, patientID).then(
                    function (patientIcd10History) {
                        $rootScope.$broadcast(Event.ICD.ICD_10.GET_PATIENT_HISTORY.SUCCESS, patientIcd10History);
                        return patientIcd10History;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.ICD.ICD_10.GET_PATIENT_HISTORY.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };

            this.getPatientMedicalProcedureHistory = function(doctorID, patientID) {
                return icdService.getPatientMedicalProcedureHistory(doctorID, patientID).then(
                    function (patientIcd9History) {
                        $rootScope.$broadcast(Event.ICD.ICD_9.GET_PATIENT_HISTORY.SUCCESS, patientIcd9History);
                        return patientIcd9History;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.ICD.ICD_9.GET_PATIENT_HISTORY.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };

            this.getFavouriteIcd9List = function(doctorID) {
                return icdService.getFavouriteIcd9List(doctorID).then(
                    function (favouriteIcd9List) {
                        $rootScope.$broadcast(Event.ICD.ICD_9.GET_FAVOURITES.SUCCESS, favouriteIcd9List);
                        return favouriteIcd9List;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.ICD.ICD_9.GET_FAVOURITES.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };

            this.addFavouriteIcd10 = function(doctorId, icd10) {
                return icdService.addFavouriteIcd10(doctorId, icd10).then(
                    function (response) {
                        $rootScope.$broadcast(Event.ICD.ICD_10.ADD_FAVORITE.SUCCESS, response);
                        return response;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.ICD.ICD_10.ADD_FAVORITE.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };

            this.addFavouriteIcd9 = function(doctorId, icd9) {
                return icdService.addFavouriteIcd9(doctorId, icd9).then(
                    function (response) {
                        $rootScope.$broadcast(Event.ICD.ICD_9.ADD_FAVORITE.SUCCESS, response);
                        return response;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.ICD.ICD_9.ADD_FAVORITE.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };

            this.deleteFavouriteIcd10 = function(doctorId, icd10) {
                return icdService.deleteFavouriteIcd10(doctorId, icd10).then(
                    function (response) {
                        $rootScope.$broadcast(Event.ICD.ICD_10.DELETE_FAVORITE.SUCCESS, response);
                        return response;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.ICD.ICD_10.DELETE_FAVORITE.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };

            this.deleteFavouriteIcd9 = function(doctorId, icd9) {
                return icdService.deleteFavouriteIcd9(doctorId, icd9).then(
                    function (response) {
                        $rootScope.$broadcast(Event.ICD.ICD_9.DELETE_FAVORITE.SUCCESS, response);
                        return response;
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.ICD.ICD_9.DELETE_FAVORITE.ERROR, error);
                        return $q.reject(error);
                    }
                )
            };
        }

        return new IcdModel();
    }
]);
